import Link from "next/link";
import { useState, useEffect } from "react";
import { MdOutlinePoll } from "react-icons/md";
import styled from "styled-components";
import { menuItems as links } from "../../../static/menuList";
import Container from "../Container";
import UserIcon from "../UserIcon";
import Logo from "./Logo";
import MobileSubMenu from "./MobileSubMenu";
import Poll from "./Poll";
import SubMenu from "./SubMenu";

const Navbar = ({ handleNavbarSession }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [showPoll, setShowPoll] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [currentPathname, setCurrentPathname] = useState("");

  const closePoll = () => setShowPoll(false);

  // Handler when the mouse enters a link
  const handleLinkMouseEnter = (label) => {
    setHoveredLink(label);
    handleNavbarSession(label);
  };

  // Handler when the mouse leaves a link
  const handleLinkMouseLeave = () => {
    setHoveredLink(null);
  };

  const closeMobileSubMenu = () => {
    setShowMobileMenu(false);
  };
  let auth = "";
  if (typeof window !== "undefined" && localStorage.getItem("auth")) {
    // Access localStorage here
    auth = JSON.parse(localStorage.getItem("auth")).data;
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentPathname(window.location.pathname);
    }
  }, []);

  return (
    <>
      <Poll show={showPoll} closePoll={closePoll} />

      <MobileSubMenu
        show={showMobileMenu}
        closeMobileSubMenu={closeMobileSubMenu}
      />

      <CustomNavBar className="bg-accent sticky top-0 left-0 w-full z-30">
        <Container className="flex justify-between h-16 items-center">
          {/* target="_blank" rel="noopener noreferrer" */}
          <Link className="block" href="/newemployeetwin">
            <a className="block">
              <Logo />
            </a>
          </Link>

          <div className="hidden md:flex items-center gap-x-8">
            {links.map((link, index) => (
              <List
                className={`mainLink cursor-pointer ${link.label === "HAP Products" ? "hover:text-blue-500 hover:underline" : ""}`}
                key={link.label}
                onMouseEnter={() => {
                  if (index < links.length - 1) {
                    handleLinkMouseEnter(link.label);
                  } else {
                    handleLinkMouseLeave();
                  }
                }}
              >
                {/*
                <Link target={link.label === "HAP Products" ? "_blank" : null} className="text-[13px] inline-block" href={link.href}>
                  <span>{link.label}</span>
                </Link>*/}
                {index === links.length - 1 ? (
                  <Link
                    target={link.label === "HAP Products" ? "_blank" : null}
                    className={`text-[13px] inline-block`}
                    href={link.href}
                  >
                    <span>{link.label}</span>
                  </Link>
                ) : (
                  <span>{link.label}</span>
                )}
                {hoveredLink === link.label && (
                  <SubMenu
                    hoveredLink={link.key}
                    close={handleLinkMouseLeave}
                  />
                )}
              </List>
            ))}
          </div>

          <div className="flex items-center gap-x-3">
            {/* <Link href={"/search"} className="h-9 w-9 bg-[#005DEE] bg-opacity-10 rounded-full p-2 flex items-center justify-center">
              <BsSearch className="text-main " />
            </Link> */}

            <div>
              <button
                className="bg-[#00a889]  rounded-lg text-white font-medium px-2 py-1 text-xs"
                onClick={() => {
                  setShowPoll((prev) => !prev);
                  handleNavbarSession("Poll");
                }}
              >
                <MdOutlinePoll className="inline-block h-7 w-7 text-white" />
              </button>
            </div>

            <div className="h-9  bg-[#005DEE] bg-opacity-10 rounded-full px-4 hidden  md:flex items-center justify-center space-x-3">
              <h5 className="text-sm text-main font-medium">Hi, {auth.name}</h5>
              <div className="h-6 w-6 bg-main  rounded-full p-1 flex items-center justify-center">
                <UserIcon />
              </div>
            </div>
          </div>
        </Container>
      </CustomNavBar>
    </>
  );
};

export default Navbar;

const List = styled.div`
  /* position: relative; */

  .subMenu {
    transition: all 0.5s ease-in;
    visibility: hidden;
    opacity: 0;

    &.active {
      opacity: 1;
      visibility: visible;
      transition: all 0.5s ease-in;
    }
  }
`;

const CustomNavBar = styled.nav`
  .mainLink:not(:last-of-type) {
    a {
      span {
        position: relative;

        &::after {
          content: "";
          display: inline-block;
           /* background-image: url("/images/logo.svg"); */
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
          height: 20px;
          width: 20px;
          vertical-align: top;
          margin-left: 3px;
          visibility: hidden;
          opacity: 0;

          transition: all 0.5s ease-in;
        }

        &:hover::after {
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
`;

